var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS2T4C2Img3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 103,
    viewBox: "0 0 100 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6219 56.1854L99.0347 86.6034L64.4128 102.953L1.72761e-05 72.5351L17.3114 60.0078L34.6219 56.1854Z",
    fill: "url(#paint0_linear_1351_27833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6219 56.1514L99.0347 86.5694L81.7237 89.7647L64.4128 102.919L0 72.5011L17.3114 59.9738L34.6219 56.1514Z",
    fill: "url(#paint1_linear_1351_27833)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0525 4.34747L85.4855 34.775L99.0253 86.5706L35.7421 56.7189L21.0525 4.34747Z",
    fill: "url(#paint2_linear_1351_27833)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0107 4.34852L85.4437 34.776L64.4337 103L0.000675587 72.5727L21.0107 4.34852Z",
    fill: "url(#paint3_linear_1351_27833)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9493 4.26709L85.6602 34.3932L70.1287 85.0798L5.02212 55.9511L20.9493 4.26709Z",
    fill: "#7F0505"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3303 4.26709L83.0413 34.3932L67.5098 85.0798L2.40315 55.9511L18.3303 4.26709Z",
    fill: "url(#paint4_linear_1351_27833)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9847 4.27148H18.3643L20.9847 5.51452V4.27148Z",
    fill: "#7F0505"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1113 85.0684H67.501L67.8201 84.0244L70.1113 85.0684Z",
    fill: "#7F0505"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1013 29.4399C66.1013 27.6498 66.6867 25.7759 67.6025 24.2068C68.5179 22.6383 69.7353 21.4143 71.0287 20.8035C72.3221 20.1927 73.5395 20.2669 74.4549 20.9708C75.3708 21.675 75.9561 22.9961 75.9561 24.7861C75.9561 26.3228 75.5247 27.9213 74.8232 29.3358L75.7676 29.7865C76.7077 28.0138 77.2635 26.031 77.2635 24.1687C77.2635 22.1331 76.5994 20.5808 75.4953 19.7318C74.3908 18.8825 72.8177 18.7239 71.0287 19.5687C69.2397 20.4135 67.6666 22.0579 66.5621 23.9504C65.458 25.8421 64.7939 28.0217 64.7939 30.0573C64.7939 32.0928 65.458 33.6452 66.5621 34.4942C67.6666 35.3435 69.2397 35.5021 71.0287 34.6573C71.1717 34.5897 71.3132 34.5171 71.4533 34.4397C71.6283 33.8211 71.3153 33.5351 70.9385 33.464C69.6788 34.0295 68.4966 33.9427 67.6025 33.2552C66.6867 32.551 66.1013 31.2299 66.1013 29.4399Z",
    fill: "#1E1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0837 26.6381C60.0837 24.8481 60.6691 22.9742 61.5849 21.405C62.5003 19.8366 63.7178 18.6125 65.0111 18.0017C66.3045 17.391 67.5219 17.4652 68.4374 18.1691C69.3532 18.8732 69.9385 20.1943 69.9385 21.9843C69.9385 23.5211 69.5071 25.1196 68.8056 26.534L69.75 26.9847C70.6901 25.212 71.2459 23.2293 71.2459 21.367C71.2459 19.3314 70.5819 17.779 69.4777 16.93C68.3732 16.0808 66.8001 15.9221 65.0111 16.767C63.2221 17.6118 61.649 19.2562 60.5445 21.1486C59.4404 23.0404 58.7764 25.2199 58.7764 27.2555C58.7764 29.2911 59.4404 30.8435 60.5445 31.6924C61.649 32.5417 63.2221 32.7003 65.0111 31.8555C65.1541 31.788 65.2957 31.7154 65.4357 31.6379C65.6107 31.0193 65.2977 30.7334 64.921 30.6623C63.6613 31.2277 62.479 31.1409 61.5849 30.4534C60.6691 29.7492 60.0837 28.4281 60.0837 26.6381Z",
    fill: "#1E1E1E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1133 13.2314C31.1133 11.4414 31.6986 9.56744 32.6144 7.99829C33.5299 6.42981 34.7473 5.20576 36.0407 4.59498C37.334 3.98421 38.5515 4.05845 39.4669 4.76233C40.3827 5.46651 40.9681 6.78758 40.9681 8.5776C40.9681 10.1143 40.5367 11.7128 39.8351 13.1273L40.7796 13.578C41.7197 11.8053 42.2754 9.82252 42.2754 7.96023C42.2754 5.92464 41.6114 4.37226 40.5073 3.52329C39.4028 2.67402 37.8296 2.51541 36.0407 3.36023C34.2517 4.20504 32.6786 5.84941 31.5741 7.74186C30.4699 9.63365 29.8059 11.8132 29.8059 13.8488C29.8059 15.8843 30.4699 17.4367 31.5741 18.2857C32.6786 19.135 34.2517 19.2936 36.0407 18.4488C36.1836 18.3812 36.3252 18.3086 36.4653 18.2312C36.6402 17.6126 36.3272 17.3266 35.9505 17.2555C34.6908 17.821 33.5086 17.7342 32.6144 17.0467C31.6986 16.3425 31.1133 15.0214 31.1133 13.2314Z",
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0947 10.4306C25.0947 8.64057 25.6801 6.76666 26.5959 5.19751C27.5113 3.62903 28.7287 2.40497 30.0221 1.7942C31.3155 1.18343 32.5329 1.25767 33.4483 1.96155C34.3642 2.66573 34.9495 3.9868 34.9495 5.77682C34.9495 7.31353 34.5181 8.91207 33.8166 10.3265L34.761 10.7772C35.7011 9.00451 36.2569 7.02174 36.2569 5.15944C36.2569 3.12386 35.5929 1.57147 34.4887 0.722506C33.3842 -0.126761 31.8111 -0.285374 30.0221 0.559444C28.2331 1.40426 26.66 3.04863 25.5555 4.94108C24.4514 6.83286 23.7874 9.01239 23.7874 11.048C23.7874 13.0836 24.4514 14.6359 25.5555 15.4849C26.66 16.3342 28.2331 16.4928 30.0221 15.648C30.1651 15.5805 30.3067 15.5078 30.4467 15.4304C30.6217 14.8118 30.3087 14.5258 29.932 14.4547C28.6723 15.0202 27.49 14.9334 26.5959 14.2459C25.6801 13.5417 25.0947 12.2206 25.0947 10.4306Z",
    fill: "#1E1E1E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_27833",
    x1: 49.5173,
    y1: 4.26709,
    x2: 83.48,
    y2: 150.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_27833",
    x1: 49.5173,
    y1: 4.26709,
    x2: 49.5173,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.574056,
    stopColor: "#8F7D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6544"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1351_27833",
    x1: 49.5173,
    y1: 4.26709,
    x2: 49.5173,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D341A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1351_27833",
    x1: 49.5173,
    y1: 4.26709,
    x2: 49.5173,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1351_27833",
    x1: 42.7223,
    y1: 15.3533,
    x2: 19.6944,
    y2: 64.1169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB4949"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS2T4C2Img3);
export default __webpack_public_path__ + "static/media/HomeS2T4C2Img3.7b6349aa49afaaef4c69373e25bf644a.svg";
export { ForwardRef as ReactComponent };